/* SDC camera finder: shared logic for the homepage hero card and the results page.
 * Data comes from snippets/sdc-finder-data.liquid (Shopify metaobjects + live prices).
 * The customer's answers travel in the URL (and sessionStorage as a backup) so the
 * results page and the booking widget never ask twice.
 */
(function () {
  'use strict';
  if (window.SDCFinder) return;

  var EURO_MAKES = ['BMW','MERCEDES-BENZ','MERCEDES','MAYBACH','AUDI','VOLKSWAGEN','VW','VOLVO','PORSCHE','LAND ROVER','RANGE ROVER','MINI','FIAT','ALFA ROMEO','JAGUAR','PEUGEOT','RENAULT','SAAB'];
  var EXOTIC_MAKES = ['ASTON MARTIN','BENTLEY','BUGATTI','FERRARI','KOENIGSEGG','LAMBORGHINI','LOTUS','MASERATI','MCLAREN','PAGANI','ROLLS-ROYCE'];
  var EURO_MODELS = ['TOYOTA|GR SUPRA'];
  // Same tier rules as the booking widget (sections/sdc-booking.liquid tierFor).
  function tierFor(make, model) {
    var mu = (make || '').toUpperCase();
    if (EXOTIC_MAKES.indexOf(mu) >= 0) return 'exotic';
    if (EURO_MAKES.indexOf(mu) >= 0 || EURO_MODELS.indexOf(mu + '|' + (model || '').toUpperCase()) >= 0) return 'european';
    return 'standard';
  }

  var COVERAGE_CH = { front: 1, front_rear: 2, three: 3 };
  // Which coverages an answer offers is never hard-coded: it's whatever its Shopify entries can book for this car
  // right now (bookableCov), so adding/removing cameras or stock running out greys coverages in and out by itself
  // (Matt 2026-10-18). Coverage snaps to front + rear when the picked one isn't offered.
  var COV_ORDER = ['front', 'front_rear', 'three'];
  var COV_TEXT = { front: 'front only', front_rear: 'front and rear', three: 'front, rear and interior' };
  var USE_CASES = { park: 'Protection while parked', prowl: 'Catching prowlers and vandals', teen: 'Keeping tabs on a new driver', acc: "Proof if I'm in an accident", best: 'I want the best camera', value: 'The best value', discreet: 'Something discreet' }; // answers to "What matters most?" (Matt 2026-10-18)

  var data = null;
  function getData() {
    if (data) return data;
    var el = document.getElementById('sdc-finder-data');
    try { data = JSON.parse(el.textContent); } catch (e) { data = { combos: [], cameras: {}, rules: [], install: {} }; }
    return data;
  }

  // Vehicle rules: which apply to this year/make/model.
  function rulesFor(v) {
    var out = { noVueroid: false, convertibleOnly: false, askConvertible: false };
    if (!v || !v.make || !v.model) return out;
    var y = parseInt(v.year, 10) || 0;
    getData().rules.forEach(function (r) {
      if (!r || !r.make || String(r.make).toLowerCase() !== v.make.toLowerCase()) return;
      if (!Array.isArray(r.models) || r.models.map(function (m) { return String(m).toLowerCase(); }).indexOf(v.model.toLowerCase()) < 0) return;
      if (r.from && y && y < r.from) return;
      if (r.to && y && y > r.to) return;
      if (r.type === 'no_vueroid') out.noVueroid = true; // S1 series only: its rear camera doesn't fit these cars; the D22's different rear camera does (Matt 2026-10-12)
      if (r.type === 'convertible_only') out.convertibleOnly = true;
      if (r.type === 'ask_convertible') out.askConvertible = true;
    });
    return out;
  }

  function channelsOf(cam) { var m = /(\d)-Channel/i.exec(cam.title || ''); return m ? parseInt(m[1], 10) : 1; }

  // Installed, all-in price in cents: camera + our SD card (VIOFO/Vueroid: 128GB, or the next size in stock) + HK4 if no kit in
  // the box + "bought our camera" install labor for the vehicle tier. null = contact us (exotic).
  function allInCents(cam, tier) {
    if (tier === 'exotic') return null;
    var d = getData(), n = channelsOf(cam);
    var label = n + (n > 1 ? ' Channels' : ' Channel') + ' / ' + (tier === 'european' ? 'European' : 'Standard');
    var install = d.install[label];
    if (install == null) return null;
    var sd = (cam.sd_brand === 'VIOFO' || cam.sd_brand === 'Vueroid') ? (d.sd128[cam.sd_brand] || 0) : 0;
    var hk = (cam.sd_brand === 'VIOFO' && !cam.kit_included) ? d.hk4 : 0;
    return cam.price + sd + hk + install;
  }
  // VIOFO/Vueroid bundles need one of our cards: no card in stock = can't be booked, don't suggest it
  function sdOk(cam) { var d = getData(); return !(cam.sd_brand === 'VIOFO' || cam.sd_brand === 'Vueroid') || d.sd128[cam.sd_brand] !== null; }
  function rounded(cents) { return Math.round(cents / 1000) * 10; } // nearest $10, as dollars

  // "Our pick" rules (Matt 2026-10-05): New driver = the Drone XC2 whenever it's shown. Otherwise,
  // when an A329S (or its screenless twins T330/T340) and the Vueroid S1 4K are both shown, the S1 4K.
  // null = no rule applies: the highest-ranked camera in the combo is the pick.
  function pickRule(shown, useCase) {
    var has = function (re) { return shown.filter(function (c) { return re.test(c.handle); })[0]; };
    if (useCase === 'teen') { var xc2 = has(/^drone-xc2/); if (xc2) return xc2.handle; }
    var s14k = has(/^vueroid-s1-4k/);
    if (s14k && has(/^viofo-(a329s|t330|t340)/)) return s14k.handle;
    return null;
  }
  // Coverages an answer can be booked in for this car (a camera in stock that fits the vehicle), in COV_ORDER
  function bookableCov(useCase, vehicle) {
    return COV_ORDER.filter(function (cov) { var r = pick(cov, useCase, vehicle); return r && r.cards.length; });
  }
  // Where coverage goes when the picked one isn't offered: front + rear if offered, else the first one offered
  function snapCov(list) { return list.indexOf('front_rear') >= 0 ? 'front_rear' : list[0]; }
  // Top 3 in-stock cameras for a combo, cheapest first. ourPick = highest-ranked one shown.
  function pick(coverage, useCase, vehicle) {
    var d = getData(), rules = rulesFor(vehicle);
    var combo = d.combos.filter(function (c) { return c.coverage === coverage && c.use_case === useCase; })[0];
    if (!combo) return null;
    var eligible = combo.cameras.map(function (h, rank) { var c = d.cameras[h]; return c && Object.assign({ handle: h, rank: rank }, c); })
      .filter(function (c) { return c && c.show && c.available && sdOk(c) && !(rules.noVueroid && /^vueroid-s1-/.test(c.handle)); });
    // Sort and tag by the price the customer sees (installed, all-in). Exotic has no online
    // price, so it falls back to the camera price for ordering.
    var tier = tierFor(vehicle && vehicle.make, vehicle && vehicle.model);
    eligible.forEach(function (c) { var x = allInCents(c, tier); c.sortPrice = x == null ? c.price : x; });
    var shown = eligible.slice(0, 3);
    var ourPick = pickRule(shown, useCase) || (shown.length ? shown[0].handle : null);
    shown.sort(function (a, b) { return a.sortPrice - b.sortPrice; });
    var pickPrice = shown.filter(function (c) { return c.handle === ourPick; }).map(function (c) { return c.sortPrice; })[0];
    // Labels: from the combo's "Card labels" list (same order as its Cameras list) when filled in,
    // otherwise automatic by price.
    var labels = Array.isArray(combo.labels) ? combo.labels : [];
    shown.forEach(function (c) {
      var custom = (labels[c.rank] || '').trim();
      c.role = custom || (c.handle === ourPick ? 'Our pick' : ''); // only 'Our pick' is tagged: no 'Budget pick' (Matt 2026-10-05), no 'Upgrade pick' (Matt 2026-10-10)
    });
    return { combo: combo, cards: shown, more: eligible.slice(3), ourPick: ourPick, rules: rules };
  }

  // URL params <-> answers
  var KEYS = { y: 'year', mk: 'make', md: 'model', zip: 'zip', cov: 'coverage', uc: 'useCase', cv: 'convertible', nl: 'notListed' };
  function toQuery(a) {
    var p = new URLSearchParams();
    Object.keys(KEYS).forEach(function (k) { var v = a[KEYS[k]]; if (v !== undefined && v !== null && v !== '' && v !== false) p.set(k, v === true ? '1' : v); });
    return p.toString();
  }
  function fromQuery(qs) {
    var p = new URLSearchParams(qs || location.search), a = {};
    Object.keys(KEYS).forEach(function (k) { if (p.has(k)) a[KEYS[k]] = p.get(k); });
    if (a.convertible) a.convertible = a.convertible === '1';
    if (a.notListed) a.notListed = a.notListed === '1';
    return a;
  }
  function save(a) { try { sessionStorage.setItem('sdcFinder', JSON.stringify(a)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem('sdcFinder') || 'null'); } catch (e) { return null; } }
  function clear() { try { sessionStorage.removeItem('sdcFinder'); } catch (e) {} }

  function money(dollars) { return '$' + dollars.toLocaleString('en-US'); }
  function fmtDate(iso) {
    if (!iso) return '';
    var p = iso.split('-').map(Number), d = new Date(p[0], p[1] - 1, p[2], 12);
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  window.SDCFinder = { pickRule: pickRule,
    getData: getData, tierFor: tierFor, rulesFor: rulesFor, pick: pick, allInCents: allInCents, rounded: rounded,
    channelsOf: channelsOf, toQuery: toQuery, fromQuery: fromQuery, save: save, load: load, clear: clear, money: money, fmtDate: fmtDate,
    COVERAGE_CH: COVERAGE_CH, USE_CASES: USE_CASES, COV_TEXT: COV_TEXT, bookableCov: bookableCov, snapCov: snapCov
  };
})();
